var Platform = {
  type: 'js',
  platform: 'browser'
};

module.exports = Platform;
